interface EmptyStateProps {
  title: string;
  body: string;
}

export function EmptyState({ title, body }: EmptyStateProps) {
  return (
    <div className="feluda-empty-state">
      <h2 className="feluda-empty-state-title">{title}</h2>
      <p className="feluda-empty-state-body">{body}</p>
    </div>
  );
}